import React, { useState } from 'react';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';
import { toastError, toastSuccess } from '@components/Toast';
import LoaderComponent from '@components/LoaderComponent';

import { MATERIAL_REJECTION_TYPES } from '@features/material-requisition/utils';
import { useRejectMaterialRequisitionMutation } from '@features/material-requisition/api/materialRequisitionApi';

import { adjustTextAreaHeight } from '@utils/Util';

const MaterialRejectionModal = ({ onCloseModal, selectedRequisition }) => {
	const [inputData, setInputData] = useState({
		rejectionReason: MATERIAL_REJECTION_TYPES[0].constant,
		description: ''
	});
	const [rejectMaterialRequisition, { isLoading }] = useRejectMaterialRequisitionMutation();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setInputData((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const handleSubmit = async () => {
		try {
			await rejectMaterialRequisition({
				requisitionId: selectedRequisition.id,
				requestBody: {
					rejectionReason:
						inputData.rejectionReason === 'OTHER'
							? inputData.description
							: inputData.rejectionReason
				}
			}).unwrap();
			toastSuccess('Material requisition rejected successfully');
			onCloseModal();
		} catch {
			toastError('Failed to reject material requisition');
		}
	};

	const renderRejectionReasons = () => {
		return MATERIAL_REJECTION_TYPES.map((item) => (
			<div className="col-md-12" key={item.constant}>
				<div className="custom-radio-box custom-radio mb-12">
					<div className="form-group d-flex align-items-center">
						<input
							type="radio"
							value={item.constant}
							id={item.constant}
							name="rejectionReason"
							onChange={handleChange}
							checked={inputData.rejectionReason === item.constant}
						/>
						<label htmlFor={item.constant} className="ml-2 mb-0 gray_dark_01 regular-14">
							{item.name}
						</label>
					</div>
				</div>
			</div>
		));
	};

	return (
		<ModalContainer>
			<LoaderComponent loading={isLoading}>
				<div className="popup-wrapper">
					<div className="common-popup material-request-details-modal">
						<ModalHeader title="What is the reason for rejection?" onClose={onCloseModal} />
						<div className="common-popup-body scroll-y-label">
							<div className="choose-purpose-box">
								<div className="row">
									{renderRejectionReasons()}
									{inputData.rejectionReason === MATERIAL_REJECTION_TYPES[1].constant && (
										<div className="col-md-12">
											<div className="form-group">
												<label htmlFor="collection">Description</label>
												<textarea
													value={inputData.description}
													placeholder="Description"
													rows={3}
													onInput={(e) => adjustTextAreaHeight(e, '84px')}
													name="description"
													onChange={handleChange}
												/>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32 ml-2" onClick={onCloseModal}>
									Cancel
								</button>
								<button className="button size32 ml-2" onClick={handleSubmit}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</LoaderComponent>
		</ModalContainer>
	);
};

export default MaterialRejectionModal;
